/**************************************************************************************************/
/*   File: /src/app/shared/models/confirm.ts                                                      */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Wednesday May 15th 2019                                                        */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Wed May 15 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { Action } from '@ngrx/store';
import { MessageType } from '../enums/message.type.enum';
/**
 * The confirm dialog model
 */
export class Confirm {
    /**
     * The type of confirm
     * @type {MessageType}
     */
    type: MessageType;
    /**
     * The cancel action
     * @type {Action}
     */
    cancel?: Action;
    /**
     * The cancel action
     * @type {Action}
     */
    do: Action;
    /**
     * The text to show (Question)
     * @type {string}
     */
    text: string;
    /**
     * The title to show
     * @type {string}
     */
    title: string;
    /**
     * The confirm text to show
     * @type {string}
     */
    confirmText: string;
    /**
     * The dismiss text to show
     * @type {string}
     */
    dismissText: string;
    /**
     * The action icon
     * @type {string}
     */
    actionIcon: string;
}